import {useProductRatingPaginationFragment} from "../../../hooks/useProductRatingPaginationFragment";
import * as React from "react";

export const PagingStatus = () => {
    const {
        model: {
            paginationModel: {
                pagination: {
                    hasItems,
                    endItemNumber,
                    totalItemCount
                }
            }
        }
    } = useProductRatingPaginationFragment();
    return (
        <div className="me-1">
            Showing <strong>{hasItems ? 1 : 0} - {endItemNumber}</strong> of <strong>{totalItemCount}</strong> <span
            className="d-none d-sm-inline">ratings</span>
        </div>
    );
};